import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./shared/styles/General.scss";
import "@koumoul/vjsf/lib/VJsf.css";
import "@koumoul/vjsf/lib/deps/third-party.js";
import "./interceptor/http-config.interceptor";
import { Chart } from "chart.js";
import VueSocketIO from "vue-socket.io-extended";
import { io } from "socket.io-client";
import ECharts from "vue-echarts/components/ECharts.vue";

// Importa los tipos de gráficos y componentes que vayas a usar
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";

// Coordinate system
import "echarts/lib/component/polar";
import "echarts/lib/component/angleAxis";
import "echarts/lib/component/radiusAxis";

import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";

Vue.component("v-chart", ECharts);

Vue.config.productionTip = false;
Chart.defaults.global.plugins = {
  datalabels: {
    display: true
  }
};

const socket = io(process.env.VUE_APP_FORMS_API as string, {
  transports: ["websocket"]
});
Vue.use(VueSocketIO, socket);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
